import { formatNumber, formatUsd } from "../../config/trading";

export function OrderTicket({ mode, order, setOrder, orderMessage, estimatedNotional, selectedTicker, submitOrder, resetPaperAccount }) {
  return (
    <div className="panel order-panel" data-testid="paper-order-panel">
      <div className="panel-head">
        <span className="label">ORDER TICKET</span>
        <span className={mode === "live" ? "live-warning" : "paper-safe"} data-testid="order-mode-label">{mode.toUpperCase()}</span>
      </div>
      <div className="ticket-grid">
        <select data-testid="order-side-select" className="terminal-input" value={order.side} onChange={(event) => setOrder((current) => ({ ...current, side: event.target.value }))}>
          <option value="buy">Buy</option>
          <option value="sell">Sell</option>
        </select>
        <select data-testid="order-type-select" className="terminal-input" value={order.order_type} onChange={(event) => setOrder((current) => ({ ...current, order_type: event.target.value }))}>
          <option value="market">Market</option>
          <option value="limit">Limit</option>
        </select>
        <input data-testid="order-quantity-input" className="terminal-input" type="number" step="0.0001" value={order.quantity} onChange={(event) => setOrder((current) => ({ ...current, quantity: event.target.value }))} />
        <input data-testid="order-price-input" className="terminal-input" type="number" placeholder={selectedTicker ? formatNumber(selectedTicker.last, 2) : "Price"} value={order.price} onChange={(event) => setOrder((current) => ({ ...current, price: event.target.value }))} disabled={order.order_type === "market"} />
      </div>
      <div className="order-summary" data-testid="order-estimated-notional">Estimated notional <b className="mono">{formatUsd(estimatedNotional)}</b></div>
      <button data-testid="submit-order-button" className={mode === "live" ? "danger-button wide" : "primary-button wide"} onClick={submitOrder}>
        {mode === "live" ? "Request Live Order" : "Execute Paper Order"}
      </button>
      {mode === "paper" && (
        <button data-testid="reset-paper-account-button" className="secondary-button wide" onClick={resetPaperAccount}>
          Reset Paper USDT
        </button>
      )}
      {orderMessage && <p className="notice" data-testid="order-result-message">{orderMessage}</p>}
      {!orderMessage && <p className="notice ghost" data-testid="order-result-message">System ready.</p>}
    </div>
  );
}